/**
 * snapshotDetailsReducer.js
 * Created by zl952fc on 11/17/2020.
 */
import * as types from '../../actions/actiontypes';
import {formBodyType, dataSortingOrder} from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';
import {normalizeScots, normalizeItProcesses, normalizeItApplications, normalizeItControls} from '../Common/bodiesSpecial';
import initialstate from '../initialstate';

export function snapshotDetailsReducer(state = initialstate.snapshotDetails, action) {
	switch (action.type) {
		case types.GET_SNAPSHOT_BY_ID:
			if (action.isPrintView === true) {
				return state;
			} else {
				return action.response || state;
			}
		default:
			return state;
	}
}

export function craSnapshotDetailsReducer(state = initialstate.craSnapshotDetails, action) {
	switch (action.type) {
		case types.GET_CRA_SNAPSHOT_BY_ID:
			return action.response || state;
		default:
			return state;
	}
}

export function getITEnvironmentSnapshotById(state = initialstate.itEnvironmentSnapshotDetails, action) {
	switch (action.type) {
		case types.GET_IT_ENVIRONMENT_SNAPSHOT_BY_ID:
			return action.response || state;
		default:
			return state;
	}
}

export function snapshotCompareDetailsReducer(state = initialstate.snapshotCompareDetails, action) {
	switch (action.type) {
		case types.GET_SNAPSHOT_COMPARE_BY_ID:
			if (action.isPrintView === true) {
				return state;
			} else {
				return action.response || state;
			}
		case types.CLEAR_SNAPSHOT_COMPARE_VIEW:
			return {};
		default:
			return state;
	}
}

export function clearRightSideSnapshotViewReducer(state = initialstate.clearRightSideSnapshotView, action) {
	switch (action.type) {
		case types.CLEAR_RIGHT_SIDE_SNAPSHOT_VIEW:
			return action.response || state;
		default:
			return 0;
	}
}

export function showHideRightSideSnapshotViewReducer(state = initialstate.showHideRightSideSnapshotView, action) {
	switch (action.type) {
		case types.SHOW_HIDE_RIGHT_SIDE_SNAPSHOT_VIEW:
			return action.response;
		default:
			return state;
	}
}
export function showHideLeftSideSnapshotViewReducer(state = initialstate.showHideLeftSideSnapshotView, action) {
	switch (action.type) {
		case types.SHOW_HIDE_LEFT_SIDE_SNAPSHOT_VIEW:
			return action.response;
		default:
			return state;
	}
}

const itFlowBodiesConfig = {
	[formBodyType.ISA315ScotItApplication]: (body) => {
		return normalizeScots(body.scots.data);
	},
	[formBodyType.ISA315ItApplicationScot]: (body) => {
		return normalizeItApplications(body.itApplications.data);
	},
	[formBodyType.ISA315ItProcessItApplication]: (body) => {
		let state = normalizeItApplications(body.itApplications.data);
		state = normalizeItProcesses(body.itProcesses.data, state);
		return state;
	},
	[formBodyType.ISA315ItProcessTask]: (body) => {
		return normalizeItProcesses(body.itProcesses.data);
	},
	[formBodyType.ISA315ItProcessItRisk]: (body) => {
		let state = normalizeItProcesses(body.itProcesses.data);
		state = normalizeItControls(body.itControls.data, state);
		return state;
	},
	[formBodyType.ISA315ItGCTestStrategy]: (body) => {
		let state = normalizeItProcesses(body.itProcesses.data);
		state = normalizeItControls(body.itControls.data, state);
		return state;
	},
	[formBodyType.ISA315SoScot]: (body) => {
		return normalizeItApplications(body.itApplications.data);
	},
	[formBodyType.ISA315ManageItSp]: (body) => {
		return normalizeItProcesses(body.itProcesses.data);
	}
};

function getItFlowBodiesMergeStrategy(formBodyTypeId) {
	const defaultStrategy = (body) => body;

	return itFlowBodiesConfig[formBodyTypeId] || defaultStrategy;
}

export function formPrintReducer(state = initialstate.formPrintData, action) {
	switch (action.type) {
		case types.GET_SNAPSHOT_BY_ID:
			if (action.isPrintView !== true) {
				return state;
			} else {
				let headersList = [],
					profileData = [],
					relatedDocuments = [],
					signOffDetails = [],
					riskFactors = [],
					riskTypes = [],
					relatedObjects = [],
					engagement = [],
					materiality = [],
					balanceSheetTableData = [],
					incomeStatemenTableData = [],
					account = [],
					helixProjects = [],
					snapshotData = [];

				const responseData = action.response;

				let slice = {};
				let bodiesList;
				if (responseData && responseData.snapshotData && responseData.snapshotData.length > 0) {
					headersList = responseData.snapshotData.map((header) => ({
						...header,
						sections: header.sections.sort(Utility.sortByMultipleKey([dataSortingOrder.knowledgeDisplayOrder, dataSortingOrder.name])).map((section) => {
							bodiesList = section.bodies.map((body) => {
								const mergeStrategyFunction = getItFlowBodiesMergeStrategy(body.bodyTypeId);
								const itSoBody = responseData.complexBodies?.itFlowBodies?.find((_body) => _body.bodyId === body.id);
								const bodyRelatedDocuments = responseData.bodyRelatedDocuments?.find((_body) => _body.bodyId === body.id);
								body.relatedDocuments = bodyRelatedDocuments?.formPrintDocumentReadModel;
								if (itSoBody) {
									body = {
										...body,
										...mergeStrategyFunction(itSoBody)
									};
								}
								return body;
							});

							return {
								...section,
								bodies: bodiesList.sort(
									Utility.sortByMultipleKey([dataSortingOrder.knowledgeDisplayOrder, dataSortingOrder.name, dataSortingOrder.customLabel])
								)
							};
						})
					}));
				}

				if (responseData && responseData.profileData) {
					profileData = responseData.profileData;
				}

				if (responseData && responseData.formRelatedDocuments) {
					relatedDocuments = responseData.formRelatedDocuments;
				}

				if (responseData && responseData.signOffDetails) {
					signOffDetails = responseData.signOffDetails;
				}

				if (responseData && responseData.formRelatedObjects) {
					relatedObjects = responseData.formRelatedObjects;
				}

				if (responseData && responseData.riskFactors) {
					riskFactors = responseData.riskFactors;
				}

				if (responseData && responseData.riskTypes) {
					riskTypes = responseData.riskTypes;
				}
				if (responseData && responseData.engagement) {
					engagement = responseData.engagement;
				}
				if (responseData && responseData.materiality) {
					materiality = responseData.materiality;
				}
				if (responseData && responseData.balanceSheetTableData) {
					balanceSheetTableData = responseData.balanceSheetTableData;
				}
				if (responseData && responseData.incomeStatemenTableData) {
					incomeStatemenTableData = responseData.incomeStatemenTableData;
				}

				if (responseData && responseData.account) {
					account = responseData.account;
				}

				if (responseData && responseData.helixProjects) {
					helixProjects = responseData.helixProjects;
				}

				if (responseData && responseData.helixProjects) {
					snapshotData = responseData.snapshotData;
				}

				return {
					...state,
					engagementId: responseData.engagementId,
					engagementDescription: responseData.engagementDescription,
					documentName: responseData.documentName,
					documentEngagementId: responseData.documentEngagementId,
					[action.documentId]: headersList,
					profileData: profileData,
					relatedDocuments: relatedDocuments,
					signOffDetails: signOffDetails,
					relatedObjects: relatedObjects,
					riskFactors: riskFactors,
					riskTypes: riskTypes,
					engagement: engagement,
					materiality: materiality,
					balanceSheetTableData: balanceSheetTableData,
					incomeStatemenTableData: incomeStatemenTableData,
					account: account,
					helixProjects: helixProjects,
					snapshotData: snapshotData,
					...slice
				};
			}
		default:
			return state;
	}
}
